import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../assets/SamsoftixLogo.jpg';
import './Navbar.css';

function Navbar() {
  const navigate = useNavigate();
  const [tapCount, setTapCount] = useState(0);
  const [lastTapTime, setLastTapTime] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdowns, setDropdowns] = useState({ blogs: false, services: false });

  // 🔐 Secret tap logic for admin login
  useEffect(() => {
    if (tapCount >= 5) {
      navigate('/alogin');
      setTapCount(0);
    }

    const timeout = setTimeout(() => setTapCount(0), 2500);
    return () => clearTimeout(timeout);
  }, [tapCount, navigate]);

  const handleClick = (e) => {
    if (e.detail === 5) navigate('/alogin');
  };

  const handleTouch = () => {
    const now = Date.now();
    if (now - lastTapTime < 600) setTapCount((prev) => prev + 1);
    else setTapCount(1);
    setLastTapTime(now);
  };

  // ✅ Close everything (Professional UX)
  const closeAllMenus = () => {
    setMenuOpen(false);
    setDropdowns({ blogs: false, services: false });
  };

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
    setDropdowns({ blogs: false, services: false }); // close dropdowns when toggling mobile
  };

  // ✅ Only one dropdown open at a time
  const toggleDropdown = (name) => {
    setDropdowns((prev) => ({
      blogs: name === 'blogs' ? !prev.blogs : false,
      services: name === 'services' ? !prev.services : false,
    }));
  };

  return (
    <nav className="navbar">
      
      {/* Logo */}
      <div
        className="logo-container"
        onClick={handleClick}
        onTouchStart={handleTouch}
        title="SamSoftix - Smart Software Solutions"
        aria-label="SamSoftix Home"
      >
        <img src={logo} alt="SamSoftix Logo" className="logo" />
        <h2 className="company-name">
          <span className="sam">Sam</span>
          <span className="softix">Softix</span>
        </h2>
      </div>

      {/* Hamburger */}
      <button
        className={`menu-toggle ${menuOpen ? 'active' : ''}`}
        onClick={toggleMenu}
        aria-label="Toggle navigation menu"
        aria-expanded={menuOpen}
      >
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </button>

      {/* Nav Links */}
      <ul className={`nav-links ${menuOpen ? 'active' : ''}`}>

        <li>
          <Link to="/" onClick={closeAllMenus}>Home</Link>
        </li>

        <li>
          <Link to="/about" onClick={closeAllMenus}>About</Link>
        </li>

        {/* Blogs */}
        <li className="dropdown">
          <button onClick={() => toggleDropdown('blogs')}>
            Blogs <span className="arrow">{dropdowns.blogs ? '▲' : '▼'}</span>
          </button>

          <ul className={`dropdown-menu ${dropdowns.blogs ? 'active' : ''}`}>
            <li><Link to="/write_blog_requirements" onClick={closeAllMenus}>Write Effective Project Requirements</Link></li>
            <li><Link to="/Create_React_Js_App" onClick={closeAllMenus}>Build a Responsive Website with React.js</Link></li>
            <li><Link to="/React_Advanced_Tips" onClick={closeAllMenus}>10 Advanced React.js Tips</Link></li>
            <li><Link to="/GetHosting" onClick={closeAllMenus}>Hosting Blog</Link></li>
            <li><Link to="/HostingerHosting" onClick={closeAllMenus}>Hostinger Hosting</Link></li>
            <li><Link to="/React_Best_Practices" onClick={closeAllMenus}>10 Best Practices for Modern Website Development</Link></li>
            <li><Link to="/StartUp_Website_2026" onClick={closeAllMenus}>Why Every Startup Needs a Professional Website in 2026</Link></li>
            <li><Link to="/AI_Startup_blog" onClick={closeAllMenus}>How Startups Can Use AI & Automation in 2026 to Grow Faster</Link></li>
            <li><Link to="/UI_Design_Principles" onClick={closeAllMenus}>10 Essential UI/UX Design Principles for 2026 Websites & Apps</Link></li>
          </ul>
        </li>

        {/* Services */}
        <li className="dropdown">
          <button onClick={() => toggleDropdown('services')}>
            Services <span className="arrow">{dropdowns.services ? '▲' : '▼'}</span>
          </button>

          <ul className={`dropdown-menu ${dropdowns.services ? 'active' : ''}`}>
            <li><Link to="/all_services" onClick={closeAllMenus}>All Services</Link></li>
            <li><Link to="/website_Service_Samsoftix" onClick={closeAllMenus}>Web Development</Link></li>
            <li><Link to="/GetHostingDomain" onClick={closeAllMenus}>Hosting & Domain Services</Link></li>
            <li><Link to="/Mobile_App_Service_SamSoftix" onClick={closeAllMenus}>Mobile Apps</Link></li>
            <li><Link to="/AI_Solutions_SamSoftix" onClick={closeAllMenus}>AI Solutions</Link></li>
            <li><Link to="/Dubai_Website_Service_SamSoftix" onClick={closeAllMenus}>Website Development for Dubai Clients</Link></li>
          </ul>
        </li>

        <li>
          <Link to="/contact" onClick={closeAllMenus}>Contact</Link>
        </li>

        <li>
          <Link to="/offers" onClick={closeAllMenus}>Limited Time Offers</Link>
        </li>

      </ul>
    </nav>
  );
}

export default Navbar;
